import { base64toImage, fileToBase64 } from "./base64Helper";

const imageExtensions = /(\/jpg|\/jpeg|\/png)$/i;

export const handleUploadFile = async(e) => {
  let files = e.target.files;
    let newFiles = []
    for (const file of files) {
      const base64 = await fileToBase64(file);
      const blob = await getImageUrl(base64)
      newFiles.push({base64, name: file.name, blob});
    }
    return newFiles;
}

export const getImageUrl = (data) => {
  const fileType = data.split(';')[0];
  let result;
  if(imageExtensions.exec(fileType)){
      result = URL.createObjectURL(base64toImage(data));
  }
  return result;
}